import useFastFormProviderContext from './useFastFormProviderContext';

function useFormId() {
  const context = useFastFormProviderContext();
  return context.formId;
}

export default useFormId;
